export const types = {
  ADD_INGREDIENT: "ADD_INGREDIENT",
  REMOVE_INGREDIENT: "REMOVE_INGREDIENT",
  SET_INGREDIENT_INPUT: "SET_INGREDIENT_INPUT",
  SET_SEARCH_KEYWORD_INPUT: "SET_SEARCH_KEYWORD_INPUT",
  CHECK_INGREDIENT_EXISTENCE: "CHECK_INGREDIENT_EXISTENCE",
  INITIALIZE_INGREDIENT_ERRORS: "INITIALIZE_INGREDIENT_ERRORS",
  SET_INGREDIENT_INPUT_EMPTY_ERROR: "SET_INGREDIENT_INPUT_EMPTY_ERROR",
  GET_RECIPES: "GET_RECIPES",
  SET_IS_DATA_LOADING: "SET_IS_DATA_LOADING",
  SET_KEYWORD_INPUT_EMPTY_ERROR: "SET_KEYWORD_INPUT_EMPTY_ERROR",
  SET_RECIPE_RESPONSE_EMPTY_ERROR: "SET_RECIPE_RESPONSE_EMPTY_ERROR",
  SET_ALPHABET_KEYWORD_INPUT_ERROR: "SET_ALPHABET_KEYWORD_INPUT_ERROR",
  SET_ALPHABET_INGREDIENT_INPUT_ERROR: "SET_ALPHABET_INGREDIENT_INPUT_ERROR",
  SET_FETCH_REQUEST_ERROR: "SET_FETCH_REQUEST_ERROR",
  CLEAR_RECIPES: "CLEAR_RECIPES",
};
